export default __webpack_public_path__ + "static/media/nitesh_rangani_cropped.52dc22ea.jpeg";